import React, { useState } from 'react';
import styles from './Contact.module.css';

function Contact() {
  // Form state
  const [formData, setFormData] = useState({
    email: '',
    subject: '',
    message: '',
    screenshot: null
  });
  
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [responseMessage, setResponseMessage] = useState('');

  // Handle input changes for text fields
  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [id]: value }));
  };

  // Handle file input change for screenshot
  const handleFileChange = (e) => {
    setFormData((prevData) => ({ ...prevData, screenshot: e.target.files[0] }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Create FormData object
    const data = new FormData();
    data.append('email', formData.email);
    data.append('subject', formData.subject);
    data.append('message', formData.message);
    if (formData.screenshot) {
      data.append('screenshot', formData.screenshot);
    }

    try {
      const response = await fetch('https://sleepy-hamlet-15893-b0b9da7c499e.herokuapp.com/support', {
        method: 'POST',
        body: data
      });
      
      if (!response.ok) {
        throw new Error('Failed to submit support ticket.');
      }
      
      const result = await response.json();
      setResponseMessage(result.message); // Success message from backend
    } catch (error) {
      setResponseMessage('There was an error submitting the support ticket. Please try again later.');
      console.error('Error:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className={styles.contact}>
      <h2 className="sectionTitle">brukerstøtte skjema</h2>
      <form className={styles.form} onSubmit={handleSubmit}>
        <label htmlFor="email">Email</label>
        <input
          type="email"
          id="email"
          placeholder="Din email..."
          required
          value={formData.email}
          onChange={handleInputChange}
        />
        
        <label htmlFor="subject">Emne</label>
        <input
          type="text"
          id="subject"
          placeholder="Emne..."
          required
          value={formData.subject}
          onChange={handleInputChange}
        />

        <label htmlFor="message">Melding</label>
        <textarea
          id="message"
          placeholder="Din Melding..."
          rows="5"
          required
          value={formData.message}
          onChange={handleInputChange}
        ></textarea>
        
        <label htmlFor="screenshot">Legg til screenshot</label>
        <input
          type="file"
          id="screenshot"
          accept="image/*"
          onChange={handleFileChange}
        />

        <button type="submit" disabled={isSubmitting}>Send</button>
      </form>
      {responseMessage && <p>{responseMessage}</p>}
    </section>
  );
}

export default Contact;
